export default __webpack_public_path__ + "static/media/isotype_white.86410627.svg";